import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { DevContext } from '../../../../App';
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBIcon,
  MDBListGroup,
  MDBListGroupItem,
  MDBBadge
} from 'mdb-react-ui-kit';
import LectureRegistration from './Index';

export default function LectureRegistrationTestWrapper() {
  // Get dev mode context
  const { isDevMode } = useContext(DevContext);
  
  // Get companyId from route params
  const { companyid } = useParams();
  
  // Form inputs - initialize companyId from route param
  const [companyId, setCompanyId] = useState(companyid || '');
  const [eventId, setEventId] = useState('cb7a916e-ed71-483a-8177-22532ab0b237');
  const [lectureId, setLectureId] = useState('');
  
  // Update companyId when route parameter changes
  useEffect(() => {
    if (companyid) {
      setCompanyId(companyid);
    }
  }, [companyid]);
  
  // Modal states
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  
  // Modal data
  const [modalCompanyId, setModalCompanyId] = useState('');
  const [modalEventId, setModalEventId] = useState('');
  const [modalLectureId, setModalLectureId] = useState('');
  
  // Saved lectures list
  const [savedLectures, setSavedLectures] = useState([]);

  // Handle create new lecture
  const handleCreateNew = () => {
    if (!companyId || !eventId) {
      alert('Bitte geben Sie Company ID und Event ID ein');
      return;
    }
    setModalCompanyId(companyId);
    setModalEventId(eventId);
    setModalLectureId(null); // No lecture ID for create mode
    setShowCreateModal(true);
  };

  // Handle edit existing lecture
  const handleEditExisting = () => {
    if (!companyId || !eventId || !lectureId) {
      alert('Bitte geben Sie alle IDs ein (Company, Event und Lecture)');
      return;
    }
    setModalCompanyId(companyId);
    setModalEventId(eventId);
    setModalLectureId(lectureId);
    setShowEditModal(true);
  };

  // Handle save callback
  const handleSaveLecture = (lectureData) => {
    console.log('Lecture saved with data:', lectureData);
    
    // Extract the actual lecture ID from the API response
    const lectureId = lectureData.id;
    
    // Add or update lecture in saved list
    const lectureInfo = {
      id: lectureId, // Use the actual ID from the API
      title: lectureData.title?.[0]?.text || 'Kein Titel',
      type: lectureData.type || 'unknown',
      language: lectureData.presentationLanguage || 'de',
      speakers: lectureData.speakers?.map(s => 
        typeof s === 'string' ? s : `${s.firstName || ''} ${s.lastName || ''}`
      ).join(', ') || 'Keine Sprecher',
      isComplete: lectureData.isValid || false,
      timestamp: new Date().toLocaleTimeString('de-DE'),
      companyId: modalCompanyId,
      eventId: modalEventId
    };
    
    setSavedLectures(prev => {
      if (modalLectureId) {
        // Update existing
        return prev.map(l => l.id === modalLectureId ? lectureInfo : l);
      } else {
        // Add new
        return [...prev, lectureInfo];
      }
    });
    
    // Close modal
    handleCloseModals();
  };
  
  // Handle edit saved lecture
  const handleEditSavedLecture = (lecture) => {
    setModalCompanyId(lecture.companyId);
    setModalEventId(lecture.eventId);
    setModalLectureId(lecture.id);
    setShowEditModal(true);
  };

  // Close modals
  const handleCloseModals = () => {
    setShowCreateModal(false);
    setShowEditModal(false);
  };

  return (
    <MDBContainer className="py-5">
      <MDBRow className="justify-content-center">
        <MDBCol md="8">
          <MDBCard>
            <MDBCardBody>
              <h2 className="mb-4">Lecture Registration Test Wrapper</h2>
              
              {isDevMode && (
                <div className="mb-4">
                  <h5 className="mb-3">Test-Eingabefelder</h5>
                  
                  <MDBRow className="mb-3">
                    <MDBCol md="4">
                      <MDBInput
                        label="Company ID"
                        value={companyId}
                        onChange={(e) => setCompanyId(e.target.value)}
                        placeholder="z.B. 12345"
                      />
                    </MDBCol>
                    <MDBCol md="4">
                      <MDBInput
                        label="Event ID"
                        value={eventId}
                        onChange={(e) => setEventId(e.target.value)}
                        placeholder="z.B. event-123"
                      />
                    </MDBCol>
                    <MDBCol md="4">
                      <MDBInput
                        label="Lecture ID (für Edit)"
                        value={lectureId}
                        onChange={(e) => setLectureId(e.target.value)}
                        placeholder="z.B. lecture-456"
                      />
                    </MDBCol>
                  </MDBRow>
                </div>
              )}

              <div className="mb-4">
                <h5 className="mb-3">Test-Aktionen</h5>
                
                <div className="d-flex gap-3">
                  <MDBBtn color="success" onClick={handleCreateNew}>
                    <MDBIcon fas icon="plus" className="me-2" />
                    Neue Lecture erstellen
                  </MDBBtn>
                  
                  {isDevMode && (
                    <MDBBtn color="primary" onClick={handleEditExisting}>
                      <MDBIcon fas icon="edit" className="me-2" />
                      Bestehende Lecture bearbeiten
                    </MDBBtn>
                  )}
                </div>
              </div>

              {isDevMode && (companyId || eventId || lectureId) && (
                <div className="mt-4 p-3 bg-light rounded">
                  <h6>Aktuelle Test-Werte:</h6>
                  <ul className="mb-0">
                    <li>Company ID: <strong>{companyId || 'Nicht gesetzt'}</strong></li>
                    <li>Event ID: <strong>{eventId || 'Nicht gesetzt'}</strong></li>
                    <li>Lecture ID: <strong>{lectureId || 'Nicht gesetzt'}</strong></li>
                  </ul>
                </div>
              )}
            </MDBCardBody>
          </MDBCard>
          
          {/* Saved Lectures List */}
          {savedLectures.length > 0 && (
            <MDBCard className="mt-4">
              <MDBCardBody>
                <h5 className="mb-3">Gespeicherte Vorträge</h5>
                <MDBListGroup>
                  {savedLectures.map((lecture) => (
                    <MDBListGroupItem key={lecture.id} className="d-flex justify-content-between align-items-center">
                      <div className="flex-grow-1">
                        <h6 className="mb-1">{lecture.title}</h6>
                        <small className="text-muted">
                          ID: {lecture.id} | Typ: {lecture.type} | Sprache: {lecture.language}
                        </small>
                        <br />
                        <small className="text-muted">Sprecher: {lecture.speakers}</small>
                      </div>
                      <div className="d-flex align-items-center gap-3">
                        <div className="text-end">
                          <MDBBadge color={lecture.isComplete ? 'success' : 'warning'}>
                            {lecture.isComplete ? 'Vollständig' : 'Unvollständig'}
                          </MDBBadge>
                          <br />
                          <small className="text-muted">{lecture.timestamp}</small>
                        </div>
                        <MDBBtn 
                          color="primary" 
                          size="sm" 
                          onClick={() => handleEditSavedLecture(lecture)}
                        >
                          <MDBIcon fas icon="edit" />
                        </MDBBtn>
                      </div>
                    </MDBListGroupItem>
                  ))}
                </MDBListGroup>
              </MDBCardBody>
            </MDBCard>
          )}
        </MDBCol>
      </MDBRow>

      {/* Create Modal */}
      <MDBModal open={showCreateModal} onClose={() => {}} staticBackdrop>
        <MDBModalDialog size="fullscreen">
          <MDBModalContent>
          
            <MDBModalBody className="p-0">
              <LectureRegistration
                companyId={modalCompanyId}
                eventId={modalEventId}
                lectureId={modalLectureId}
                onSaveLecture={handleSaveLecture}
                onCloseRequest={handleCloseModals}
                isModal={true}
              />
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      {/* Edit Modal */}
      <MDBModal open={showEditModal} onClose={() => {}} staticBackdrop>
        <MDBModalDialog size="fullscreen">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Lecture bearbeiten (ID: {modalLectureId})</MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody className="p-0">
              <LectureRegistration
                companyId={modalCompanyId}
                eventId={modalEventId}
                lectureId={modalLectureId}
                onSaveLecture={handleSaveLecture}
                onCloseRequest={handleCloseModals}
                isModal={true}
              />
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </MDBContainer>
  );
}